export default __webpack_public_path__ + "static/Artificial-intelligence-e9238df401b1cf80d35c1fe2008b8a45.webp";